import { render, staticRenderFns } from "./AutorizacaoPortabilidadeModal.vue?vue&type=template&id=4190e5db&lang=true&"
import script from "./AutorizacaoPortabilidadeModal.vue?vue&type=script&lang=js&"
export * from "./AutorizacaoPortabilidadeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports